import request from '@/utils/request';
const swHead = '/api';

// 录制初始化上传
export const multiUploadTask = (data) => {
  return request.post(swHead + `/upload/project-upload-task`, data);
};

// 获取新分片url
export const newMultiParts = (data) => {
  return request.post(swHead + `/upload/new-parts`, data);
};

// aws分片上传
export const newUploadTask = (data) => {
  return request.post(swHead + `/upload/task`, data);
};

// 分片整合
export const completeUpload = (data) => {
  return request.post(swHead + `/upload/test-complete`, data);
};

// 创建项目
export const createProject = (data) => {
  return request.post(swHead + `/project/`, data);
};
// 创建项目
export const createYoutube = (data) => {
  return request.post(swHead + `/project/youtube`, data);
};

// 删除项目
export const deleteProject = (id) => {
  return request.delete(swHead + `/project/${id}`);
};
